export const postTypes = {
  All: 0,
  Service: 1,
  Product: 2,
  Art: 3,
  Photo: 4,
  Videos: 5,
};

export const postTypesByValue = {
  0: 'All',
  1: 'Service',
  2: 'Product',
  3: 'Art',
  4: 'Photo',
  5: 'Videos',
};
export const sellerTypeValue = {
  0: 'Empty',
  1: 'Agent',
  2: 'Distributor',
  3: 'Dealer',
};
export const came_fromData = [
  {
    title: "Invited by Arkchat user",
    value: "invited_by_arkchat_user",
  },
  {
    title: "Referred by a friend",
    value: "referred_by_a_friend",
  },
  {
    title: "Influencer",
    value: "influencer",
  },
  {
    title: "Linkedin",
    value: "linkedin",
  },
  {
    title: "Facebook",
    value: "facebook",
  },
  {
    title: "Instagram",
    value: "instagram",
  },
  {
    title: "Twitter",
    value: "twitter",
  },
  {
    title: "Email",
    value: "email",
  },
  {
    title: "Google",
    value: "google",
  },
  {
    title: "YouTube",
    value: "youTube",
  },
  {
    title: "Tiktok",
    value: "tiktok",
  },
  {
    title: "Pinterest",
    value: "pinterest",
  },
];